module.exports = __webpack_public_path__ + "static/img/lxventures.b9befe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lxventures.jpg
// module id = n0rF
// module chunks = 0